<div class="container">
  <div class="language-toggle">
    <button (click)="setLanguage('is')" [class.active]="language === 'is'">Íslenska</button>
    <button (click)="setLanguage('en')" [class.active]="language === 'en'">English</button>
  </div>

  <div class="text-center" style="margin: 20px 0;">
    <img src="https://ello-bucket.s3.amazonaws.com/ello/6407d3b9a083250fe818445f43df85f2630f72db.svg" alt="">
  </div>

  <div *ngIf="language === 'is'">
    <h1>Skilmálar og skilyrði</h1>
    <p>Högnun slf. (Kt. 4410110910)</p>
    <p>Reykjavík, Ísland</p>
    <p>6. júlí, 2025</p>
    <h2>Viðurkenning á notendaskilmálum</h2>
    <p>Þessir skilmálar notkunar eru gerðir milli þín og ELLO („Félagið“, „við“, forritinu eða „okkar“). Eftirfarandi
      skilmálar og skilyrði, ásamt öllum skjölum sem þau vísa sérstaklega til (sameiginlega nefnd „Skilmálar notkunar“),
      stýra aðgangi þínum að og notkun ELLO farsímaforritsins, þar á meðal öllu efni, virkni og þjónustu sem boðið er
      upp á í gegnum ELLO farsímaforritið („ELLO App“). Vinsamlegast lestu skilmálana vandlega áður en þú byrjar að nota
      ELLO. Með því að nota ELLO forritið samþykkir þú að vera bundinn af þessum skilmálum notkunar og
      persónuverndarstefnu okkar, sem er að finna á neðst á heimasíðunni. Notandi er bundin því að samþykkja þessa
      skilmála vilji hann fá aðgang að forritinu.</p>
    <p>ELLO er í boði fyrir notendur sem eru að minnsta kosti 15 ára. Með því að nota forritið staðfestirðu að þú ert
      löglega fullorðinn til að gera bindandi samning við Félagið og uppfyllir öll skilyrðin. Ef þú uppfyllir ekki öll
      þessi skilyrði getur þú ekki fengið aðgang að eða notað ELLO forritið.</p>
    <h2>Breytingar á skilmálum notkunar</h2>
    <p>Við gætum endurskoðað og uppfært þessa skilmála hvenær sem er. Allar breytingar eru strax virkar þegar við birtum
      þær, og gilda um allan aðgang og notkun ELLO forritsins eftir það. Viðvarandi notkun þín á forritinu eftir
      birtingu breyttu skilmálanna þýðir að þú samþykkir breytingarnar. Það er viðurkennt að þú skalt athuga þessa síðu
      í hvert skipti sem þú færð aðgang að forritinu svo þú sért meðvitaður um breytingarnar, þar sem þær eru bindandi
      fyrir þig.</p>
    <h2>Aðgangur að ELLO forritun og öryggi reikninga</h2>
    <p>Við áskiljum okkur rétt til að draga til baka eða breyta forritinu, og allri þjónustu eða efni sem við veitum í
      gegnum ELLO App, að eigin geðþótta án fyrirvara. Við tökum ekki ábyrgð ef af einhverjum ástæðum er ELLO App ekki
      tiltækt á einhverjum tíma eða í einhvern tíma. Frá tíma til tíma gætum við takmarkað aðgang að sumum hlutum ELLO
      App, eða öllu ELLO App, fyrir notendur, þar á meðal skráð notendur.</p>
    <p>Þú ert ábyrgur fyrir bæði:</p>
    <ul>
      <li>Að gera allar nauðsynlegar ráðstafanir svo þú hafir aðgang að ELLO forritinu.</li>
      <li>Að tryggja að allir þeir sem fá aðgang að ELLO forritinu séu meðvitaðir um þessa skilmála notkunar og fari
        eftir þeim.</li>
    </ul>
    <p>Til að fá aðgang að forritinu eða sumum af þeim eiginleikum sem það býður, gætirðu verið beðin um að veita
      ákveðnar skráningarupplýsingar eða aðrar upplýsingar. Það er skilyrði fyrir notkun þinni á forritinu að allar
      upplýsingar sem þú veitir séu réttar, núverandi og kláraðar. Þú samþykkir að allar upplýsingar sem þú veitir til
      að skrá þig að aðild í forritið eða á annan hátt, þar á meðal, en ekki takmarkað við, í gegnum notkun á hvaða
      gagnvirkum eiginleikum sem eru á ELLO App, eru stjórnað af persónuverndarstefnu okkar og þú samþykkir aðgerðir sem
      við tökum varðandi upplýsingar þínar í samræmi við persónuverndarstefnu okkar.</p>
    <p>Ef þú velur, eða færð, notendanafn, lykilorð, eða aðra upplýsingar sem hluta af öryggisferlum okkar, verður þú að
      meðhöndla slíkar upplýsingar sem trúnaðarmál, og þú mátt ekki afhjúpa þær fyrir neinum öðrum einstaklingum eða
      aðilum. Þú samþykkir einnig að reikningurinn þinn er persónulegur fyrir þig og samþykkir að veita ekki neinum
      öðrum aðgang að ELLO forritinu eða hluta þess með því að nota notendanafn, lykilorð eða aðrar öryggisupplýsingar.
      Þú samþykkir að tilkynna okkur strax um óheimilan aðgang að eða notkun á notendanafni þínu eða lykilorði eða öðrum
      öryggisbresti.</p>
    <p>Við höfum rétt til að óvirkja hvaða notendanafn, lykilorð eða aðra auðkenningu, hvort sem þau eru valin af þér
      eða veitt af okkur, hvenær sem er að eigin frumkvæði, fyrir hvaða ástæðu sem er, þar á meðal ef, að okkar mati, þú
      hefur brotið gegn einhverjum skilmálum þessa skilmála notkunar.</p>
    <p>Þú samþykkir að deila ekki kóðum Vildarklúbbsins með öðrum og að notkun þeirra sé eingöngu takmörkuð við þig.</p>
    <h2>Hugverkaréttindi</h2>
    <p>ELLO forritið og allt efni, eiginleikar og virkni þess (þar á meðal, en ekki takmarkað við, allar upplýsingar,
      hugbúnað, texta, skjámyndir, myndir, vídeó og hljóð, og hönnun, val og skipulag þeirra) eru eign Félagsins,
      réttindahafa þess eða annarra veitenda slíkra efna og eru vernduð af íslenskum og alþjóðlegum höfundarrétti,
      vörumerkjarétti, einkaleyfi, viðskiptaleynd og öðrum lögum um hugverkaréttindi eða einkarétt.</p>
    <p>Þessir notkunarskilmálar leyfa þér að nota forritið aðeins fyrir persónulega, ekki-viðskiptalega notkun. Þú mátt
      ekki endurgera, dreifa, breyta, búa til afleidd verk, sýna opinberlega, framkvæma opinberlega, endurbirta, hlaða
      niður, geyma, eða senda efni af ELLO forritinu, nema sem hér segir:</p>
    <ul>
      <li>Tæki þitt má tímabundið geyma afrit af slíkum efnum við aðgang þinn að og skoðun á þeim efnum.</li>
    </ul>
    <p>Þú mátt ekki:</p>
    <ul>
      <li>Breyta eða afrita eitthvað efni frá ELLO App.</li>
      <li>Eyða eða breyta neinum tilkynningum um höfundarrétt, vörumerki eða aðra réttindi af afritum efnis frá ELLO
        App.</li>
    </ul>
    <p>Þú mátt ekki fá aðgang að eða nota neinn hluta forritsins eða neinar þjónustu eða efni sem eru í boði í gegnum
      forritið í viðskipta tilgangi.</p>
    <p>Ef þú prentar, afritar, breytir, hleður niður eða á annan hátt notar eða veitir einhverjum öðrum aðgang að
      einhverju hluta ELLO forritsins í andstöðu við skilmála notkunar, mun réttur þinn til að nota forritið stöðvast
      strax og þú verður að, að okkar ákvörðun, að skila eða eyða öllum afritum efnis sem þú hefur gert. Engin réttur,
      eignarhald, eða hagsmunir í forritinu eða neinu efni á forritsins færast til þín, og öll réttindi sem ekki eru
      sérstaklega veitt af Félaginu. Öll notkun á forritinu sem ekki er sérstaklega heimiluð af þessum skilmálum
      notkunar brýtur gegn þessum skilmálum og getur brotið gegn höfundarrétti, vörumerkjarétti og öðrum lögum.</p>
    <h2>Bannaðar notkunir</h2>
    <p>Þú mátt nota ELLO forritið aðeins í löglegum tilgangi og í samræmi við þessa skilmála notkunar. Þú samþykkir að
      nota ekki ELLO forritið:</p>
    <ul>
      <li>Á neinn hátt sem brýtur gegn skýrum lögum eller reglugerðum, hvort sem er alríkis, ríkis, sveitarfélags eða
        alþjóðlegum (þ.m.t. án takmarkana, lögum um útflutning gagna eða hugbúnaðar til og frá Íslandi eða öðrum
        löndum).</li>
      <li>Í þeim tilgangi að nýta, skaða, eða reyna að nýta eða skaða börn á einhvern hátt með því að kynna þeim
        óviðeigandi efni, biðja um persónuupplýsingar, eða á annan hátt.</li>
      <li>Til að senda, eller afla sendingar á, auglýsingum eða kynningarefnum, þar á meðal „spam pósti“, „keðjubréfum“,
        „ruslpósti“, eller öðrum svipuðum beiðnum.</li>
      <li>Til að þykjast eller reyna að þykjast vera Félagið, starfsmanni þess, öðrum notanda, eller öðrum einstaklingi
        eða aðila (þ.m.t. án takmarkana, með því að nota tölvupóstfang tengd einhverjum af framangreindum).</li>
      <li>Til að taka þátt í öðrum aðgerðum sem takmarka eða hindra notkun eða ánægju annarra notenda forritsins, eller
        sem, að okkar mati, gæti skaðað Félagið eða notendur þess.</li>
    </ul>
    <p>Einnig samþykkirðu að:</p>
    <ul>
      <li>Nota ekki forritið á neinn hátt sem gæti skaðað eða skert ELLO forritið eða truflað notkun annarra aðila í
        því.</li>
      <li>Nota ekki neina vél eller aðra sjálfvirka tækni, ferla eða aðferðir til að fá aðgang að forritinu í hvaða
        tilgangi sem er, þar á meðal að fylgjast með eller afrita efni ELLO forritsins.</li>
      <li>Nota ekki neina handvirka aðferð til að fylgjast með eller afrita efni forritsins, eller í öðrum tilgangi sem
        ekki er sérstaklega heimilað í þessum skilmálum notkunar, án fyrirfram skriflegs samþykkis okkar.</li>
      <li>Nota ekki neina tækni, hugbúnað eða venjur sem trufla eðlilega virkni forritsins.</li>
      <li>Reyna ekki að fá óheimilaðan aðgang að, trufla, skaða, eller raska neinum hlutum ELLO forritsins, þjóninum sem
        forritið er hýst á, eller hvaða þjónn, tölvu eða gagnagrunni sem tengdur er því.</li>
      <li>Reyna ekki að trufla eðlilega virkni forritsins á annan hátt.</li>
    </ul>
    <h2>Traust á upplýsingum sem birtar eru</h2>
    <p>Upplýsingar sem lagðar eru fram á eða í gegnum ELLO forritið eru eingöngu aðgengilegar til almennra upplýsinga.
      Við ábyrgjumst ekki réttmæti, heildstæðni, eða gagnsemi þessara upplýsinga. Allt traust sem þú leggur á slíkar
      upplýsingar er eingöngu á þína eigin ábyrgð. Við fráskiljum alla ábyrgð og skyldu sem leiða af því að treysta á
      slíkt efni af þínum hálfu eða annarra notenda ELLO forritsins, eller annarra sem kunna að fá upplýsingar um efni
      þess.</p>
    <p>Þetta forrit gæti innihaldið efni frá þriðju aðilum, þar á meðal efni frá öðrum notendum, réttindahöfum þriðju
      aðila, dreifingaraðilum eller skýrslugreinum. Allar yfirlýsingar og skoðanir sem koma fram í þessum efnum, og
      allar greinar og svör við spurningum og öðrum efni, að öðru leyti en því efni sem Félagið veitir, eru eingöngu
      skoðanir og ábyrgð þess sem veitir það efni. Þessar upplýsingar endurspegla ekki nauðsynlega skoðanir Félagsins.
      Við erum ekki ábyrg fyrir, né berum ábyrgð á þér eða þriðja aðila, fyrir efni eða réttmæti hvaða efnis sem veitt
      er af þriðja aðila.</p>
    <h2>Breytingar á forritinu</h2>
    <p>Við gætum uppfært efni á þessu ELLO forritinu af og til, en efnið er ekki nauðsynlega fullkomið eða uppfært.
      Eitthvað af efni forritsins gæti verið úrelt á einhverjum tíma, og við höfum enga skyldu til að uppfæra slíkt efni
      þó við gerum okkar besta.</p>
    <h2>Upplýsingar um þig og notkun þín á forritinu</h2>
    <p>Allar upplýsingar sem við söfnum á forritinu eru háðar persónuverndarstefnu okkar
      [https://ello.is/wp-content/uploads/2021/10/Privacy-policy-ello.pdf]. Með því að nota ELLO forritið samþykkir þú
      allar aðgerðir sem við tökum varðandi upplýsingar þínar í samræmi við persónuverndarstefnuna.</p>
    <h2>Aðildarkaup og aðrir kaupskilmálar</h2>
    <p>Við bjóðum upp á þjónustu sem byggir á aðild að efni innan ELLO forritsins. Þessar aðildir eru hægt að kaupa
      innan forritsins. Dæmi um þetta eru innkaup gerð í gegnum ytri forritabúð, svo sem Apple App Store eða Google Play
      Store.</p>
    <p>Þú samþykkir eftirfarandi skilmála fyrir notkun á aðildarbundnu efni innan ELLO App:</p>
    <ul>
      <li>Sérhver kaup í gegnum ytri verslun með forritum er háð skilmálum, skilyrðum og öðrum leyfum þeirrar verslunar;
        og unnin í gegnum greiðslugátt sem notuð er af viðkomandi verslun.</li>
      <li>Þú munir beina öllum greiðslutengdum vandamálum sem þú átt í við verslunina sjálfa vegna innkaupa í forriti
        eða endurgreiðslubeiðna.</li>
      <li>Að aðildir að ELLO forritinu séu sjálfkrafa endurnýjaðar á fyrsta degi næsta greiðslutímabils.</li>
      <li>Að aðildargjald muni gilda óháð því hversu mikið eða hversu oft þú hefur aðgang að eða notar aðildina.</li>
      <li>Ef aðildargjöld sem rukkuð eru á reikninginn þinn eru ekki greidd af einhverjum ástæðum gætum við stöðvað
        aðild þína þar til greiðsla hefur verið innt af hendi að fullu.</li>
    </ul>
    <h2>Greiðslur og aðild</h2>
    <p>Við áskiljum okkur rétt til að breyta gjöldum fyrir áskriftarþjónustu okkar hvenær sem er, en aðeins fyrir næsta
      og framtíðar gjaldtímabil. Fylgjandi skilmálar tengjast uppsögn áskriftar að ELLO forritinu:</p>
    <ul>
      <li>Þú getur sagt upp áskriftinni þinni hvenær sem er.</li>
      <li>Nema þú segir upp áskriftinni að minnsta kosti 24 klukkustundum áður en næsta gjaldtímabil hefst, verður þú
        rukkaður fyrir næsta tímabil.</li>
      <li>Eftir uppsögn muntu áfram hafa aðgang að ELLO forritinu í það sem eftir er af tímabilinu.</li>
      <li>Ef áskriftin þín er In-App Purchase, verður þú að slökkva á „sjálfvirkri endurnýjun,“ segja upp áskriftinni í
        stillingum, og/eða segja upp í gegnum viðeigandi forrita verslun.</li>
      <li>Við bjóðum ekki upp á endurgreiðslur eða inneignir fyrir ónotaða áskriftartímabil, óviljandi kaup,
        heilsufarsástand, eða aðra svipaða ástæðu eða atburð, nema lög kveði á um það.</li>
      <li>Ef þú ert óánægður af einhverjum ástæðum, vinsamlegast hafðu samband við teymið okkar á ello@ello.is</li>
    </ul>
    <h2>Hlekkir innan ELLO forritsins</h2>
    <p>Forritið inniheldur hlekki á aðrar síður frá þriðja aðila, og eru þessir hlekkir fyrir þín þægindi. Þetta felur í
      sér hlekki í auglýsingum, þar á meðal banner auglýsingum og styrktum hlekkjum. Við höfum enga stjórn á efni þeirra
      síða eða auðlinda og tökum ekki ábyrgð á þeim eða á tapi eða skaða sem kann að leiða af notkun þeirra. Ef þú
      ákveður að fara á einhverjar þriðja aðila vefsíður sem tengdar eru ELLO forritinu, gerirðu það algjörlega á þína
      eigin áhættu og samkvæmt skilmálum og skilyrðum fyrir slíkar vefsíður.</p>
    <h2>Landfræðilegar takmarkanir</h2>
    <p>Eigandi ELLO forritsins er staðsettur í Reykjavík, Íslandi. Við gerum engar kröfur um að forritið eða hvaða efni
      sem það inniheldur sé aðgengilegt eða viðeigandi utan Íslands. Aðgangur að forritinu kann ekki að vera löglegur
      fyrir ákveðna einstaklinga eða í ákveðnum löndum. Ef þú færð aðgang að forritinu utan Íslands, gerirðu það á eigin
      forsendum og berð ábyrgð á að fara eftir staðbundnum lögum.</p>
    <h2>Frádráttur ábyrgðar</h2>
    <p>Þú skilur að við getum ekki og ábyrgjumst ekki að ELLO App verði frítt fyrir veirum eða öðrum eyðileggjandi kóða
      þó viðeigandi ráðstafanir um vírusvörn og öryggi hafi verið gerðar. Þú berð ábyrgð á að innleiða nægjanlegar
      aðferðir og prófanir til að uppfylla sérstakar kröfur þínar um vírusvörn og nákvæmni gagna inntaks og úttaks, og
      að viðhalda aðferðum utan vefsins okkar til að draga úr áhættu þess að árás verði gerð á tækið þitt sem og aðganga
      þína og upplýsingar sem þeim fylgir.</p>
    <h2>Löggjöf og dómstólar</h2>
    <p>Öll málefni tengd ELLO forritinu og þessum skilmálum um notkun, og hverjar ágreiningar eða kröfur sem stafa af
      eða tengjast þeim (í hverju tilviki, þar á meðal utan samnings ágreiningar eða kröfu), skulu stjórnast af og
      túlkuð í samræmi við innri lög Íslands án tillits til vals eða árekstrarreglna (hvort sem í Íslandi eða öðrum
      lögsagnarum).</p>
    <p>Öll lögfræðileg mál, aðgerðir, eða málsókn sem stafa af, eða tengjast þessum skilmálum um notkun eða ELLO
      forritsins skulu settar fyrir eingöngu í ríkisdómstólum Íslands, þó að við höldum réttinum til að fara með
      aðgerðir, málsóknir, eða mál gegn þér vegna brots á þessum skilmálum um notkun í landi þínu eða öðrum viðeigandi
      landi. Þú afsalar þér einhverra og allra andmæla við framkvæmd dómstólaskipulags yfir þér í slíkum dómstólum.</p>
    <h2>Gerðardómur</h2>
    <p>Allur ágreiningur sem stafar af þessum skilmálum um notkun ELLO forritsins, þar á meðal ágreiningar sem stafa af
      eða varða túlkun þeirra, brot, ógildingu, vanefnd, eða uppsagnir, skulu vera til loka og bindandi gerðardóms
      samkvæmt lögum.</p>
    <h2>Afhending og aðskiljanleiki</h2>
    <p>Engar undanþágur af hálfu fyrirtækisins á neinum skilmálum eða skilyrðum sem sett eru fram í þessum skilmálum um
      notkun skulu teljast frekari eða áframhaldandi undanþága af slíkum skilmálum eða skilyrðum eða undanþága á neinum
      öðrum skilmálum eða skilyrðum, og hversu skortur fyrirtækisins á að framfylgja rétt eða skilyrði samkvæmt þessum
      skilmálum um notkun skal ekki teljast undanþága af slíkum rétti eða skilyrði.</p>
    <p>Ef eitthvert ákvæði þessa skilmála um notkun er talið af dómstólum eða öðru sambandi um stjórnvaldsrétt að vera
      ógilt, ólöglegt, eða ekki hægt að framfylgja af hvaða ástæðu sem er, skal það ákvæði eytt eða takmarkað að
      lágmarki þannig að hin ákvæði skilmálanna um notkun haldist áfram í fullu gildi.</p>
    <h2>Heildarsamningur</h2>
    <p>Skilmálar um notkun og persónuverndarstefna okkar mynda heildstæðan samning milli þín og ELLO varðandi forritið
      og víkja fyrir öllum fyrri og samtímis skilningi, samningum, yfirlýsingum, og ábyrgðum, bæði skriflegum og
      munnlegum, varðandi forritið.</p>
    <h2>Athugasemdir þínar og áhyggjur</h2>
    <p>Beinist til ELLO@ELLO.is</p>
  </div>

  <div *ngIf="language === 'en'">
    <h1>Terms and Conditions</h1>
    <p>Högnun slf. (Reg. No. 4410110910)</p>
    <p>Reykjavík, Iceland</p>
    <p>July 6, 2025</p>
    <h2>Acknowledgment of Terms of Use</h2>
    <p>These terms of use are entered into between you and ELLO (“the Company,” “we,” the app, or “our”). The following
      terms and conditions, together with any documents they expressly refer to (collectively referred to as “Terms of
      Use”), govern your access to and use of the ELLO mobile application, including all content, functionality, and
      services offered through the ELLO mobile application (“ELLO App”). Please read the terms carefully before you
      start using ELLO. By using the ELLO App, you agree to be bound by these Terms of Use and our Privacy Policy, which
      can be found at the bottom of the homepage. The user is required to accept these terms to gain access to the app.
    </p>
    <p>ELLO is available to users who are at least 15 years old. By using the app, you confirm that you are legally of
      age to enter into a binding contract with the Company and meet all the conditions. If you do not meet all these
      conditions, you may not access or use the ELLO App.</p>
    <h2>Changes to the Terms of Use</h2>
    <p>We may revise and update these terms at any time. All changes are effective immediately when we post them and
      apply to all access and use of the ELLO App thereafter. Your continued use of the app following the posting of
      revised terms means you accept the changes. It is acknowledged that you should check this page each time you
      access the app to be aware of the changes, as they are binding on you.</p>
    <h2>Access to the ELLO App and Account Security</h2>
    <p>We reserve the right to withdraw or amend the app, and any service or material we provide through the ELLO App,
      at our sole discretion without notice. We will not be liable if, for any reason, the ELLO App is unavailable at
      any time or for any period. From time to time, we may restrict access to some parts of the ELLO App, or the entire
      ELLO App, to users, including registered users.</p>
    <p>You are responsible for both:</p>
    <ul>
      <li>Making all necessary arrangements to have access to the ELLO App.</li>
      <li>Ensuring that all persons who access the ELLO App are aware of these Terms of Use and comply with them.</li>
    </ul>
    <p>To access the app or some of the features it offers, you may be asked to provide certain registration details or
      other information. It is a condition of your use of the app that all the information you provide is correct,
      current, and complete. You agree that all information you provide to register for membership in the app or
      otherwise, including, but not limited to, through the use of any interactive features on the ELLO App, is governed
      by our Privacy Policy, and you consent to actions we take regarding your information in accordance with our
      Privacy Policy.</p>
    <p>If you choose, or are provided with, a username, password, or other information as part of our security
      procedures, you must treat such information as confidential, and you must not disclose it to any other person or
      entity. You also agree that your account is personal to you and agree not to provide any other person with access
      to the ELLO App or portions of it using your username, password, or other security information. You agree to
      notify us immediately of any unauthorized access to or use of your username or password or any other security
      breach.</p>
    <p>We have the right to disable any username, password, or other identifier, whether chosen by you or provided by
      us, at any time at our sole discretion, for any reason, including if, in our opinion, you have violated any of
      these Terms of Use.</p>
    <p>You agree not to share Loyalty Club codes with others and that their use is strictly limited to you.</p>
    <h2>Intellectual Property Rights</h2>
    <p>The ELLO App and all its content, features, and functionality (including, but not limited to, all information,
      software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned
      by the Company, its licensors, or other providers of such material and are protected by Icelandic and
      international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights
      laws.</p>
    <p>These Terms of Use permit you to use the app only for personal, non-commercial use. You must not reproduce,
      distribute, modify, create derivative works, publicly display, publicly perform, republish, download, store, or
      transmit any material from the ELLO App, except as follows:</p>
    <ul>
      <li>Your device may temporarily store copies of such materials incidental to your accessing and viewing those
        materials.</li>
    </ul>
    <p>You must not:</p>
    <ul>
      <li>Modify or copy any material from the ELLO App.</li>
      <li>Delete or alter any copyright, trademark, or other proprietary rights notices from copies of materials from
        the ELLO App.</li>
    </ul>
    <p>You must not access or use any part of the app or any services or materials available through the app for
      commercial purposes.</p>
    <p>If you print, copy, modify, download, or otherwise use or provide any other person with access to any part of the
      ELLO App in breach of the Terms of Use, your right to use the app will stop immediately, and you must, at our
      discretion, return or destroy any copies of the materials you have made. No right, title, or interest in the app
      or any content on the app is transferred to you, and all rights not expressly granted are reserved by the Company.
      Any use of the app not expressly permitted by these Terms of Use is a breach of these terms and may violate
      copyright, trademark, and other laws.</p>
    <h2>Prohibited Uses</h2>
    <p>You may use the ELLO App only for lawful purposes and in accordance with these Terms of Use. You agree not to use
      the ELLO App:</p>
    <ul>
      <li>In any way that violates any applicable federal, state, local, or international law or regulation (including,
        without limitation, any laws regarding the export of data or software to and from Iceland or other countries).
      </li>
      <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to
        inappropriate content, asking for personal information, or otherwise.</li>
      <li>To send, or procure the sending of, any advertising or promotional material, including “spam,” “chain
        letters,” “junk mail,” or any other similar solicitation.</li>
      <li>To impersonate or attempt to impersonate the Company, its employee, another user, or any other person or
        entity (including, without limitation, by using email addresses associated with any of the foregoing).</li>
      <li>To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of the app, or which, as
        determined by us, may harm the Company or users of the app.</li>
    </ul>
    <p>You also agree to:</p>
    <ul>
      <li>Not use the app in any manner that could damage or impair the ELLO App or interfere with any other party’s use
        of it.</li>
      <li>Not use any robot or other automated technology, processes, or methods to access the app for any purpose,
        including monitoring or copying any of the ELLO App’s content.</li>
      <li>Not use any manual method to monitor or copy the app’s content, or for any other purpose not expressly
        permitted in these Terms of Use, without our prior written consent.</li>
      <li>Not use any technology, software, or practices that interfere with the normal functioning of the app.</li>
      <li>Not attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the ELLO App, the
        server on which the app is hosted, or any server, computer, or database connected to it.</li>
      <li>Not attempt to interfere with the normal functioning of the app in any other way.</li>
    </ul>
    <h2>Reliance on Information Posted</h2>
    <p>The information presented on or through the ELLO App is made available solely for general information purposes.
      We do not warrant the accuracy, completeness, or usefulness of this information. Any reliance you place on such
      information is strictly at your own risk. We disclaim all liability and responsibility arising from any reliance
      placed on such materials by you or any other users of the ELLO App, or by anyone who may be informed of any of its
      contents.</p>
    <p>This app may include content from third parties, including content from other users, third-party licensors,
      distributors, or reporters. All statements and opinions expressed in these materials, and all articles and
      responses to questions and other content, other than the content provided by the Company, are solely the opinions
      and responsibility of the person providing that content. These materials do not necessarily reflect the opinions
      of the Company. We are not responsible, or liable to you or any third party, for the content or accuracy of any
      materials provided by third parties.</p>
    <h2>Changes to the App</h2>
    <p>We may update the content on this ELLO App from time to time, but its content is not necessarily complete or
      up-to-date. Any of the app’s content may be out of date at any given time, and we are under no obligation to
      update such content, though we do our best.</p>
    <h2>Information About You and Your Use of the App</h2>
    <p>All information we collect on the app is subject to our Privacy Policy
      [https://ello.is/wp-content/uploads/2021/10/Privacy-policy-ello.pdf]. By using the ELLO App, you consent to all
      actions we take with respect to your information in accordance with the Privacy Policy.</p>
    <h2>Membership Purchases and Other Purchase Terms</h2>
    <p>We offer services based on membership to content within the ELLO App. These memberships can be purchased within
      the app. Examples include purchases made through external app stores, such as the Apple App Store or Google Play
      Store.</p>
    <p>You agree to the following terms for the use of membership-based content within the ELLO App:</p>
    <ul>
      <li>Any purchase through an external app store is subject to the terms, conditions, and other licenses of that
        store and processed through the payment gateway used by the respective store.</li>
      <li>You will direct all payment-related issues you have to the store itself regarding in-app purchases or refund
        requests.</li>
      <li>Memberships to the ELLO App are automatically renewed on the first day of the next billing period.</li>
      <li>Membership fees will apply regardless of how much or how often you access or use the membership.</li>
      <li>If membership fees charged to your account are not paid for any reason, we may suspend your membership until
        payment has been made in full.</li>
    </ul>
    <h2>Payments and Membership</h2>
    <p>We reserve the right to change fees for our subscription services at any time, but only for the next and future
      billing periods. The following terms relate to the termination of a subscription to the ELLO App:</p>
    <ul>
      <li>You may cancel your subscription at any time.</li>
      <li>Unless you cancel your subscription at least 24 hours before the next billing period begins, you will be
        charged for the next period.</li>
      <li>After cancellation, you will continue to have access to the ELLO App for the remainder of the period.</li>
      <li>If your subscription is an In-App Purchase, you must turn off “auto-renewal,” cancel the subscription in
        settings, and/or cancel through the relevant app store.</li>
      <li>We do not offer refunds or credits for unused subscription periods, accidental purchases, health conditions,
        or other similar reasons or events, unless required by law.</li>
      <li>If you are dissatisfied for any reason, please contact our team at ello@ello.is.</li>
    </ul>
    <h2>Links Within the ELLO App</h2>
    <p>The app contains links to other sites from third parties, and these links are for your convenience. This includes
      links in advertisements, including banner advertisements and sponsored links. We have no control over the content
      of those sites or resources and accept no responsibility for them or for any loss or damage that may arise from
      your use of them. If you decide to access any third-party websites linked to the ELLO App, you do so entirely at
      your own risk and subject to the terms and conditions for such websites.</p>
    <h2>Geographical Restrictions</h2>
    <p>The owner of the ELLO App is located in Reykjavík, Iceland. We make no claims that the app or any of its content
      is accessible or appropriate outside of Iceland. Access to the app may not be legal for certain individuals or in
      certain countries. If you access the app outside Iceland, you do so on your own initiative and are responsible for
      compliance with local laws.</p>
    <h2>Disclaimer of Liability</h2>
    <p>You understand that we cannot and do not guarantee that the ELLO App will be free from viruses or other
      destructive code, although appropriate antivirus and security measures have been implemented. You are responsible
      for implementing sufficient procedures and checks to satisfy your specific requirements for antivirus protection
      and accuracy of data input and output, and for maintaining a means external to our site to mitigate the risk of an
      attack on your device, as well as your accounts and associated information.</p>
    <h2>Governing Law and Courts</h2>
    <p>All matters relating to the ELLO App and these Terms of Use, and any disputes or claims arising from or related
      to them (in each case, including non-contractual disputes or claims), shall be governed by and construed in
      accordance with the internal laws of Iceland without regard to choice or conflict of law provisions (whether in
      Iceland or any other jurisdiction).</p>
    <p>Any legal suit, action, or proceeding arising out of, or related to, these Terms of Use or the ELLO App shall be
      instituted exclusively in the state courts of Iceland, although we retain the right to bring any suit, action, or
      proceeding against you for breach of these Terms of Use in your country or any other relevant country. You waive
      any and all objections to the exercise of jurisdiction over you by such courts.</p>
    <h2>Arbitration</h2>
    <p>Any dispute arising from these Terms of Use of the ELLO App, including disputes arising from or concerning their
      interpretation, violation, invalidity, non-performance, or termination, shall be subject to final and binding
      arbitration in accordance with the law.</p>
    <h2>Waiver and Severability</h2>
    <p>No waiver by the Company of any term or condition set forth in these Terms of Use shall be deemed a further or
      continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of the
      Company to enforce a right or provision under these Terms of Use shall not constitute a waiver of such right or
      provision.</p>
    <p>If any provision of these Terms of Use is held by a court or other tribunal of competent jurisdiction to be
      invalid, illegal, or unenforceable for any reason, such provision shall be eliminated or limited to the minimum
      extent such that the remaining provisions of the Terms of Use will continue in full force and effect.</p>
    <h2>Entire Agreement</h2>
    <p>The Terms of Use and our Privacy Policy constitute the entire agreement between you and ELLO regarding the app
      and supersede all prior and contemporaneous understandings, agreements, representations, and warranties, both
      written and oral, regarding the app.</p>
    <h2>Your Comments and Concerns</h2>
    <p>Contact us at ELLO@ELLO.is</p>
  </div>
</div>

<style>
  .container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }

  .language-toggle {
    margin-bottom: 20px;
    text-align: right;
  }

  .language-toggle button {
    background:#a7b59b;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: opacity 0.2s ease-in-out;
    margin-left: 10px;
  }

  .language-toggle button:first-child {
    margin-left: 0;
    /* no extra space before the first button */
  }

  .language-toggle button.active {
    background-color: #7b8873;
    color: white;
  }
</style>